import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import Navbar from "./Navbar";
import BarChart from "./BarChart";
import PieChartComp from "./PieChartComp";
import "../admin/admin.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import axiosClient from "../../axios-client";
import { useNavigate } from "react-router-dom";

const Main = () => {
  const [showPopup, setShowPopup] = useState(true);
  const [users, setUsers] = useState([]);
  const [UserCount, setUserCount] = useState("");
  const [loading, setLoading] = useState(true);
  const [ReportCount, setReportCount] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axiosClient.get("/users/userlist");
        const userList = response.data.users;
        setUserCount(userList.length);

        setUsers(response.data.users);
        console.log("User Data:", userList);
        console.log(`Total Users: ${userList.length}`);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    const adminToken = localStorage.getItem("Admin_Token");
    if (!adminToken) {
      navigate("/admin/login");
    }
  }, [navigate]);

 useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await axiosClient.get("/reports/getReport");
      const count = response.data.length
      console.log("data",count);
      setReportCount(count)
      } catch (error) {
        console.error("Error fetching reports:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  return (
    <>
      <SideBar />
      <Navbar />

      <div className="home">
        <div className="toggle-sidebar" style={{ display: "none" }}>
          <i className="bi bi-menu"></i>
        </div>
        <div className="admin-banner">
          <div className="row">
            {showPopup && (
              <div className="col-lg-12 dash-up">
                <div className="dash-strip">
                  <div>
                    <h3>Congrats!! you can now modify your application</h3>
                    <p>
                      Keep all the information up to date with minimal effort
                    </p>
                  </div>
                  <div>
                    <i
                      className="bi bi-x"
                      onClick={() => setShowPopup(false)}
                    ></i>
                  </div>
                </div>
                <div className="over"></div>
              </div>
            )}
            <div className="p-4 relative mx-auto grid max-w-[40rem] grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3">
            <div className="">
              <div className="admin-dashbox">
                <h2>
                  <i className="bi bi-person"></i> Total Registered Users :
                </h2>
                {/* <h3 className="pt-2">10</h3> */}
                <ul className="overlapping-avatar">
                  <li>
                    <img src="/images/user.png" alt="" />
                  </li>
                  <li>
                    <img src="/images/user2.png" alt="" />
                  </li>
                  <li>
                    <img src="/images/user3.png" alt="" />
                  </li>
                  <li>
                    <span>{UserCount}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="">
              <div className="admin-dashbox">
                <h2>
                  <i className="bi bi-bookmark"></i> Total subscriber      :{" "}
                </h2>
                <div className="dash-space">
                  <div>
                    {/* <h3 className="pt-2">500</h3>
                    <p>
                      50% <i className="bi bi-arrow-up"></i> from last year
                    </p> */}
                  </div>
                  {/* <div className="dash-img">
                    <img src="/images/graph.png" alt="" />
                  </div> */}
                </div>
              </div>
            </div>
            <div className="">
              <div className="admin-dashbox">
                <h2>
                  <i className="bi bi-bookmark"></i> Total Report : {" "} {ReportCount}
                </h2>
                <div className="dash-space">
                  <div>
                    {/* <h3 className="pt-2">{ReportCount}</h3> */}
                    {/* <p>
                      50% <i className="bi bi-arrow-up"></i> from last year
                    </p> */}
                  </div>
                  <div className="dash-img">
                    <img src="/images/report.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
            </div>
            
            {/* <div className="col-lg-12 p-4">
              <div className="row dash-recent">
                <div className="col-lg-6">
                  <div className="recents">
                    <h5>Recent Activities</h5>
                    <div className="recent-tile">
                      <span>11:25 AM</span>
                      <p>A new User Logged in</p>
                    </div>
                    <div className="recent-tile">
                      <span>11:25 AM</span>
                      <p>A new User Logged in</p>
                    </div>
                    <div className="recent-tile">
                      <span>11:25 AM</span>
                      <p>A new User Logged in</p>
                    </div>
                    <div className="recent-tile">
                      <span>11:25 AM</span>
                      <p>A new User Logged in</p>
                    </div>
                    <div className="recent-tile">
                      <span>11:25 AM</span>
                      <p>A new User Logged in</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="sales">
                    <div className="sales-1">
                      <h5>Total Shares Worth</h5>
                      <div className="d-flex">
                        <div>
                          <i className="bi bi-tag"></i>
                        </div>
                        <div>
                          <h6>
                            ₹ 3.6 Cr <span>- 34 %</span>
                          </h6>
                          <p>Compared to 4.8 Cr last year</p>
                        </div>
                      </div>
                    </div>
                    <div className="sales-2">
                      <h5>Repeat Rate</h5>
                      <div className="d-flex">
                        <div>
                          <i className="bi bi-tag"></i>
                        </div>
                        <div>
                          <h6>
                            ₹ 3.6 Cr <span>- 34 %</span>
                          </h6>
                          <p>Compared to 4.8 Cr last year</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="col-lg-12 p-4">
              <div className="row dash-recent">
                <div className="col-lg-6">
                  <div className="recents">
                    <h5>Sales Comparison</h5>
                    <div className="py-4">
                      <BarChart />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="recents">
                    <h5>Top Sales</h5>
                    <div className="recent-sale">
                      <div className="d-flex align-items-center">
                        <div>
                          <span>SA</span>
                        </div>
                        <div>
                          <h6>Sale Admin</h6>
                          <p>Sales</p>
                        </div>
                      </div>
                      <div>
                        <h5>₹ 5000</h5>
                        <p>900</p>
                      </div>
                    </div>
                    <div className="recent-sale">
                      <div className="d-flex align-items-center">
                        <div>
                          <span>SA</span>
                        </div>
                        <div>
                          <h6>Sale Admin</h6>
                          <p>Sales</p>
                        </div>
                      </div>
                      <div>
                        <h5>₹ 5000</h5>
                        <p>900</p>
                      </div>
                    </div>
                    <div className="recent-sale">
                      <div className="d-flex align-items-center">
                        <div>
                          <span>SA</span>
                        </div>
                        <div>
                          <h6>Sale Admin</h6>
                          <p>Sales</p>
                        </div>
                      </div>
                      <div>
                        <h5>₹ 5000</h5>
                        <p>900</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* 
            <div className="col-lg-12 p-4">
              <div className="row dash-recent">
                <div className="col-lg-6">
                  <div className="recents">
                    <h5>Transactions</h5>
                    <div className="recent-sale">
                      <div className="d-flex align-items-center">
                        <div>
                          <span>SA</span>
                        </div>
                        <div>
                          <h6>Sale Admin</h6>
                          <p>Sales</p>
                        </div>
                      </div>
                      <div>
                        <h5>₹ 5000</h5>
                        <p>900</p>
                      </div>
                    </div>
                    <div className="recent-sale">
                      <div className="d-flex align-items-center">
                        <div>
                          <span>SA</span>
                        </div>
                        <div>
                          <h6>Sale Admin</h6>
                          <p>Sales</p>
                        </div>
                      </div>
                      <div>
                        <h5>₹ 5000</h5>
                        <p>900</p>
                      </div>
                    </div>
                    <div className="recent-sale">
                      <div className="d-flex align-items-center">
                        <div>
                          <span>SA</span>
                        </div>
                        <div>
                          <h6>Sale Admin</h6>
                          <p>Sales</p>
                        </div>
                      </div>
                      <div>
                        <h5>₹ 5000</h5>
                        <p>900</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="recents">
                    <h5>Income Breakdown</h5>
                    <div className="py-4 d-flex justify-content-center">
                      <PieChartComp />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="col-lg-12 p-4">
              <div className="row dash-recent">
                <div className="col-lg-12">
                  <div className="recents">
                    <h5>Additional Information</h5>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
